export default __webpack_public_path__ + "static/049-97f1902673efd3bd664bbd85feb8460a.jpg";